module.exports = __webpack_public_path__ + "img/circle-star.a4ca5f57.svg";